import './PrivacyPolicy.css';
import { EMAIL_PRIVACY } from './config';
import { useTranslation } from 'react-i18next';

function LegalNotice() {
  const { t } = useTranslation();

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>{t('legalNoticePage.title')}</h1>
        <p className="last-updated">{t('legalNoticePage.subtitle')}</p>

        <div className="policy-intro">
          <p>{t('legalNoticePage.intro')}</p>
        </div>

        <section className="policy-section">
          <h2>{t('legalNoticePage.companyInfo')}</h2>
          <div className="info-box">
            <p><strong>{t('legalNoticePage.companyName')}:</strong> Кактус Соушъл ЕООД</p>
            <p><strong>{t('legalNoticePage.internationalName')}:</strong> Cactus Social Ltd.</p>
            <p><strong>{t('legalNoticePage.legalForm')}:</strong> Еднолично дружество с ограничена отговорност ({t('legalNoticePage.legalFormValue')})</p>
            <p><strong>{t('legalNoticePage.uic')}:</strong> 208807738</p>
          </div>
        </section>

        <section className="policy-section">
          <h2>{t('legalNoticePage.registeredOffice')}</h2>
          <div className="info-box">
            <p>ул. Шипченски проход № 18, бл. А, ет. 3</p>
            <p>р-н Слатина, гр. София, п.к. 1113</p>
            <p>България (Bulgaria)</p>
          </div>
        </section>

        <section className="policy-section">
          <h2>{t('legalNoticePage.management')}</h2>
          <div className="info-box">
            <p><strong>{t('legalNoticePage.managerOwner')}:</strong> Ефрат Хасанов Феимов</p>
            <p><strong>{t('legalNoticePage.country')}:</strong> България (Bulgaria)</p>
          </div>
        </section>

        <section className="policy-section">
          <h2>{t('legalNoticePage.contact')}</h2>
          <div className="info-box">
            <p><strong>{t('legalNoticePage.email')}:</strong> <a href={`mailto:${EMAIL_PRIVACY}`}>{EMAIL_PRIVACY}</a></p>
            <p><strong>{t('legalNoticePage.website')}:</strong> cactusnorms.com</p>
          </div>
        </section>

        <footer className="policy-footer">
          <p>
            <a href="/privacy">{t('common.privacyPolicy')}</a> |
            <a href="/terms">{t('common.termsOfUse')}</a> |
            <a href={`mailto:${EMAIL_PRIVACY}`}>{t('legalNoticePage.contact')}</a>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default LegalNotice;